import { TextField } from 'react-admin';

import { B2bCompanyDocumentDetails } from '@Common/types/bo/b2b/companies';

import { ShowFields, ShowSection, ShowWithNavigation } from '@sh4res/bo-common/components';
import { UpdateGenericDocument } from '@sh4res/bo-common/components/UpdateDocument';
import { DocumentLinkField, UTCDateField } from '@sh4res/bo-common/fields';
import { useCanAccess } from '@sh4res/bo-common/hooks/useCanAccess';

export function CompanyDocumentsShow() {
  const testId = 'BoExternalCompanyDocumentsShow';
  const canEditDocuments = useCanAccess({
    resource: 'companies/documents',
    action: 'edit',
  });
  const navigateBack = () => -1 as const;

  return (
    <ShowWithNavigation
      actions={false}
      title="resources.companies/documents.title"
      navigateTo={navigateBack}
      titleActions={<></>}
      button={
        canEditDocuments ? (
          <UpdateGenericDocument<B2bCompanyDocumentDetails>
            nameSource="document_name"
            documentUrlSource="document_url"
            testId={`${testId}UpdateDocument`}
          />
        ) : (
          <></>
        )
      }>
      <ShowSection label="resources.companies/documents.sections.details">
        <ShowFields<B2bCompanyDocumentDetails>
          fields={{
            id: <TextField data-testid={`${testId}_IdField`} />,
            document_name: <TextField data-testid={`${testId}_DocumentNameField`} />,
            document_url: (
              <DocumentLinkField
                source="url"
                title="document_name"
                data-testid={`${testId}_DocumentUrlField`}
              />
            ),
            document_comment: <TextField data-testid={`${testId}_DocumentCommentField`} />,
            source: <TextField data-testid={`${testId}_SourceField`} />,
            created_at: <UTCDateField data-testid={`${testId}_CreatedAtField`} />,
            updated_at: <UTCDateField data-testid={`${testId}_UpdatedAtField`} />,
          }}
        />
      </ShowSection>
    </ShowWithNavigation>
  );
}
